'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var types = {
  STRING: 'string',
  NUMBER: 'number',
  SELECT: 'select',
  TEXT_AREA: 'text_area'
};
var showInSharedList = exports.showInSharedList = false;
exports.default = types;